export const paramMap = new Map([
  ['home', { paramType: 'review', defaultContent: 'ssp.help.default.review' }],
  ['my-profile', { paramType: 'profile', defaultContent: 'ssp.help.default.profile' }],
  ['my-location', { paramType: 'locations', defaultContent: 'ssp.help.default.locations' }],
  ['my-subscription', { paramType: 'alerts', defaultContent: 'ssp.help.default.alerts' }],
  ['my-additionalInformation', { paramType: 'information', defaultContent: 'ssp.help.default.information' }],
]);
